import React from 'react';
import PropTypes from 'prop-types';

import activatedIcon from '../../img/activated.png';

class FeatureList extends React.Component {
  constructor(props) {
    super(props);
    this.hide.bind(this);
  }

  hide() {
    this.props.hideFeaturesList();
  }

  render() {
    const activeFeatures = this.props.features.filter(feature => feature.active);
    const percentActive = Math.floor((activeFeatures.length / this.props.features.length) * 100);

    const features = this.props.features
      .map((feature) => {
        const link = feature.feature.reference === 'mql-plus-leads'
          ? <a href="/mql-plus-leads" className={`l-yp__cta btn btn--xs btn--${feature.active ? 'activated' : 'feature'}`}>Learn more</a>
          : '';

        let leadCount = feature.lead_count || 0;
        if (leadCount == 0) {
          leadCount = '';
        } else {
          leadCount = `${leadCount} leads`;
        }

        const actions = feature.active ? (
          <div className="l-yp__activated activated-badge">
            <img alt="" className="activated-badge__img" src={activatedIcon} />
            Activated
          </div>
        ) : (
          <div className="l-yp__actions">
            <div className="l-yp__total t-yp-total">{leadCount}</div>
            {link}
          </div>
        );

        return (
          <div className={`l-yp__option feature-card feature-card--${feature.active ? 'activated' : 'feature'}`} key={feature.feature_id}>
            <div className="l-yp__content">
              <h3 className="t-yp-feature-title">{feature.feature.name}</h3>

              <p className="t-yp-feature-sub">
                {feature.feature.description}
              </p>

              {actions}
            </div>
          </div>
        );
      });

    return (
      <div className="l-yp">
        <div className="l-yp__title">
          <h2 className="t-yp-title">
            Your Products
            <span className="l-yp__progress progress-badge">
              {percentActive || 0}% Active
            </span>
          </h2>
          <button onClick={() => this.hide()} type="button" className="l-yp__hide t-yp-hide">
            Hide this
          </button>
        </div>

        <div className="l-yp__options">
          {features}
        </div>
      </div>
    );
  }
}

FeatureList.propTypes = {
  features: PropTypes.array,
  hideFeaturesList: PropTypes.func,
};

FeatureList.defaultProps = {
  features: [],
  hideFeaturesList: () => {},
};

export default FeatureList;
